module.exports = __webpack_public_path__ + "img/Giordano Courtage_Accueil en haut.bb6bfc12.png";